import { IEmployeeItem, EmployeeItem } from "./employeeItem";

export interface IEmployeeItems {
    items: IEmployeeItem[];
    hasMore: boolean;
    page: number;
}

export class EmployeeItems implements IEmployeeItems {
    items: IEmployeeItem[];
    hasMore: boolean;
    page: number;

    constructor();
    constructor(obj: IEmployeeItems);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.items = [];
        if (obj && obj.items) {
            for (let i = 0; i < obj.items.length; i++) {
                this.items.push(new EmployeeItem(obj.items[i]));
            }
        }
    }
}